// Capture and scrub before ordinary auth initialization. Never persist this capability.
const url = new URL(window.location.href);
const value =
  url.pathname === '/customer-recovery'
    ? new URLSearchParams(url.hash.slice(1)).get('recovery')
    : null;
export const customerRecoveryCapability = value && /^[A-Za-z0-9_-]{43}$/.test(value) ? value : null;
if (url.pathname === '/customer-recovery') {
  history.replaceState(null, '', '/customer-recovery');
  for (const key of [
    'sqi-password-setup-pending',
    'sqi-password-setup-user',
    'sqi-password-setup-operation',
  ])
    sessionStorage.removeItem(key);
}
